import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';

// 图表复制（后端复制模式） 后端: createChart old_id 模式
export function copyChart(params: {
  old_id: string;
  name: string;
  game_code: string;
  create_time: string;
  name_cn?: string;
  label?: string;
  category?: string;
}) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/createChart',
    method: 'post',
    data: params,
    rawData: true,
  };
  return datalabHttp(options);
}

// 从个人空间分享任务到业务空间，或者删除业务空间任务  后端: 向勇刚
export function shareChart(params: {
  game_code: string; // 游戏code
  task_id: string; // 任务id
  operation_type: number; // 操作类型： 0：删除 1：分享
}) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/shareChart',
    method: 'post',
    data: params,
    useCustomTips: true
  };
  return datalabHttp(options);
}